import { useEffect } from 'react'
import { Link } from 'react-router'
import * as Sentry from '@sentry/react'
import { useIntercom } from 'react-use-intercom'
import { AppBar, Grid, Toolbar, useGlobalState } from '@trinity/components'
import MobileNav from './MobileNav'
import Nav from './Nav'
import { DealerLogo } from './shared'

export function NavBar() {
  const { user, onMobile, onTablet, onLaptop } = useGlobalState()
  const { boot, shutdown } = useIntercom()
  const imageSize = onMobile ? 250 : onTablet || onLaptop ? 185 : 275

  useEffect(() => {
    Sentry.setTag('login_id', user?.id)
  }, [user])

  useEffect(() => {
    boot({
      email: user?.dealer?.email ?? '',
      userId: String(user?.id),
      name: user?.dealer?.name,
      userHash: user?.userHash ?? '',
    })

    if (onMobile) {
      shutdown()
    }
  }, [boot, onMobile, shutdown, user])

  return (
    <AppBar
      position='static'
      sx={{ bgcolor: 'common.white', boxShadow: theme => theme.elevation.divider, transform: 'none' }}
    >
      <Toolbar sx={{ height: { mobile: 80, tablet: 90 } }}>
        <Grid container justifyContent='space-between' alignItems='center' wrap='nowrap' width={1}>
          <Grid sx={{ flex: { tablet: 2 }, pl: { tablet: 3 } }}>
            <Link to='dealer-home'>
              <DealerLogo url={user?.dealer?.logo} position='left' width={imageSize} />
            </Link>
          </Grid>
          {onMobile || onTablet ? <MobileNav /> : <Nav />}
        </Grid>
      </Toolbar>
    </AppBar>
  )
}
